<template>
	<layout-login>
		<div class="main-login" :style="`background-image: url(${companyBgUrl})`">
			<div class="background-opacity"></div>
			<section class="login">
				<div class="login-logo">
					<img
						:src="loginLogo"
						alt="praktiko logo"
						height="131"
						width="345"
					>
				</div>
				<div v-if="!send" class="login-subtitle">
					<p v-if="!tokenPassword" class="ma-0">¿No puedes ingresar a tu cuenta?</p>
					<span :style="`color:${$appColors.primary}`">RESTABLECE TU CONTRASEÑA</span>
				</div>
				<form class="login-inputs" id="login-form" @submit.prevent="signin">
					<v-layout wrap align-center justify-center>
						<v-flex xs12 text-xs-left v-if="!send && !tokenPassword">
							<span
								class="caption login-caption"
							>
								Correo Electrónico
							</span>
							<v-text-field
								autocomplete="off"
								background-color="transparent"
								box
								color="success"
								class="login-input"
								:height="48"
								hide-details
								placeholder="Email/Usuario"
								type="email"
								v-model="user"
							></v-text-field>
						</v-flex>
						<v-flex xs12 v-else-if="!tokenPassword">
							<div class="message-send">
								Hemos enviado un enlace a tu correo
								electrónico para restablecer tu contraseña
							</div>
						</v-flex>
						<template v-else>
							<v-flex xs12 text-xs-left>
								<span
									class="caption login-caption"
								>
									Nueva Contraseña
								</span>
								<v-text-field
									box
									autocomplete="off"
									background-color="transparent"
									class="login-input"
									hide-details
									placeholder="Contraseña"
									:append-icon="showPass ? 'visibility' : 'visibility_off'"
									:type="showPass ? 'text' : 'password'"
									:height="48"
									v-model="password"
									@click:append="showPass = !showPass"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12 text-xs-left>
								<span
									class="caption login-caption"
								>
									Repetir Nueva Contraseña
								</span>
								<v-text-field
									box
									autocomplete="off"
									background-color="transparent"
									class="login-input"
									hide-details
									placeholder="Contraseña"
									:append-icon="showPass ? 'visibility' : 'visibility_off'"
									:type="showPass ? 'text' : 'password'"
									:height="48"
									v-model="repeatPassword"
									@click:append="showPass = !showPass"
								>
								</v-text-field>
								<span
									v-if="repeatPassword !== password"
									class="caption"
									:style="`color:${$appColors.error}`"
								>
									Las contraseñas no coinciden
								</span>
							</v-flex>
						</template>
					</v-layout>
				</form>
				<div v-if="!send || tokenPassword" class="login-footer">
					<v-btn
						accesskey="13"
						class="login-btn"
						:class="{ disabled: isLoading }"
						:disabled="isLoading || (send && (!password && !repeatPassword)) || repeatPassword !== password || (!send && !user)"
						form="login-form"
						:loading="isLoading"
						:style="`background-color:${$appColors.primary}`"
						type="submit"
					>
						<template v-if="!tokenPassword">
							Reestablecer Contraseña
						</template>
						<template v-else>
							Cambiar Contraseña
						</template>
					</v-btn>
				</div>
				<a href="/login">
					<span
						class="text-password"
						:style="`color:${$appColors.primary}`"
					>
						Volver a Iniciar Sesión
					</span>
				</a>
			</section>
		</div>
	</layout-login>
</template>

<script>
function created() {
	this.tokenPassword = this.$route.query.token;
	if (this.tokenPassword) {
		this.send = true;
	}
}

async function signin() {
	this.isLoading = true;
	const userData = {};
	const url = !this.send && !this.tokenPassword ? 'password/email' : 'password/reset';
	if (!this.send && !this.tokenPassword) {
		userData.email = this.user;
		userData.codeApp = process.env.APP_CODE;
	} else {
		userData.password = this.password;
		userData.token = this.tokenPassword;
	}
	try {
		await this.$httpPraktiko.post(`external-api/${url}`, userData);
		if (!this.send) {
			this.send = true;
		}
		const text = !this.tokenPassword ? 'Correo enviado correctamente.' :
			'Contraseña cambiada correctamente.';
		this.$store.dispatch('showSnackBar', { text, color: 'success' });
		if (this.tokenPassword) {
			this.goTo('login');
		}
	} catch (e) {
		let text = '';
		if (e.status === 500) {
			text = 'Error del servidor';
		} else if (e.status === 400) {
			if (this.tokenPassword) {
				text = 'El token es inválido o ya ha caducado.';
			} else if (e.data.message === 'CUSTOMER_NOT_FOUND') {
				text = 'Usuario incorrecto';
			} else if (e.data.error === 'Method Not Allowed') {
				text = 'No se ha encontrado el usuario';
			}
		} else if (e.status === 401) {
			if (e.data.message === 'TOKEN_HAS_EXPIRED') {
				text = 'El token ha caducado.';
			} else if (this.tokenPassword) {
				text = 'El token es inválido';
			}
		}
		this.$store.dispatch('showSnackBar', { text, color: 'error' });
	} finally {
		this.isLoading = false;
	}
}

function loginLogo() {
	return process.env.LOGO_LOGIN;
}

function data() {
	return {
		companyBgUrl: '/static/img/login/background-praktiko.jpg',
		companyLoginLogo: process.env.COMPANY_LOGIN_LOGO,
		isLoading: false,
		password: '',
		repeatPassword: '',
		showPass: false,
		user: '',
		tokenPassword: '',
		send: false,
	};
}

export default {
	name: 'reset-password',
	computed: {
		loginLogo,
	},
	created,
	data,
	methods: {
		signin,
	},
};
</script>

<style lang="scss" scoped>
.text-password {
	border-style: none;
	font-family: font(regular);
	font-size: size(medium);
	margin-top: 20.5px;
	text-align: center;
	text-decoration: none !important;
}

a {
	text-decoration: none !important;
}

.login-subtitle {
	color: color(tooltip-gray);
	font-family: font(regular);
	font-size: size(xlarge19);
	margin-bottom: 25px;

	span {
		font-family: font(bold);
	}
}

.login-caption {
	color: #aeaeae;
	font-size: size(small13);
}

.main-login {
	@include flex-around;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100vh;

	.login {
		left: 150px;
		position: absolute;
		text-align: center;
		width: 315px;
		z-index: 5;

		.login-logo {
			margin-bottom: 50px;
		}

		.login-header {
			color: map-get($colors, white);
			font-family: map-get($fonts, lato-regular);
			font-size: map-get($sizes, medium22);
			margin: 0 auto 54px;
			width: 314px;
		}

		.login-inputs {
			font-size: 24px;
			margin-bottom: 30px;
			position: relative;
			width: 100%;

			.login-inputs-txt {
				@include flex-space-between;

				.login-inputs-group {
					width: 90%;

					.login-input {
						@include txt-config(open-regular, medium16);
						color: map-get($colors, white);
						height: 60px;
						outline: none;
						width: 100%;
					}

					.login-error-message {
						@include txt-config(open-regular, small);
						color: map-get($colors, red-error);
						float: left;
					}
				}
			}

			.login-spacer {
				border: 1px solid map-get($colors, subheaderText);
				opacity: 0.7;
				width: 100%;
			}
		}

		.login-footer {
			@include flex-around;

			.login-footer-pass {
				color: map-get($colors, blue-btn);
				font-family: map-get($fonts, open-regular);
				font-size: map-get($sizes, medium16);
			}

			.login-btn {
				@include btn(
					#37abd0,
					white,
					100px,
					48px,
					280px,
					auto,
					center,
					lato-bold,
					medium18
				);
				font-family: font(regular);
				font-size: size(xlarge);
				margin-bottom: 22px;
				outline: none;
				text-transform: none !important;
			}

			.login-btn:active {
				@include active-btn;
				font-size: 18px !important;
			}

			.disabled {
				@include btn(
					white,
					#37abd0,
					100px,
					48px,
					280px,
					auto,
					center,
					lato-bold,
					medium18
				);
			}
		}
	}
	
	.login-info {
		.login-info-text {
			color: map-get($colors, white);
			font-family: map-get($fonts, lato-regular);
			font-size: map-get($sizes, medium18);
			margin-bottom: 30px;
		}

		.login-info-btn {
			@include btn(
				blue-btn,		
				white,
				5px,
				45px,
				127px,
				auto,
				center,
				lato-regular,
				large
			);
			cursor: pointer;
			display: block;
			text-decoration: none !important;
		}

		.login-info-btn:active {
			@include active-btn;
		}
	}
}

@keyframes autofill {
	to {
		color: white;
		background: transparent;
	}
}

input:-webkit-autofill {
	animation-name: autofill;
	animation-fill-mode: both;
	background-color: transparent !important;
}

.background-opacity {
	background-image: linear-gradient(280deg, rgba(255, 255, 255, 0.41),
		rgba(255, 255, 255, 0.96) 76%,
		rgba(255, 255, 255, 0.96));
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;	
}

.icon-eyes {
	position: absolute;
	top: 70px;
	right: 20px;
}

.message-send {
	align-items: center;
	background-color: color(gray-light);
	border: 1px solid#ababab;
	border-radius: 4px;
	color: color(tooltip-gray);
	display: flex;
	font-family: font(light);
	font-size: size(medium);
	height: 103px;
	justify-content: center;
	line-height: normal;
	padding: 0px 30px;
	width: 316px;
}
</style>



// WEBPACK FOOTER //
// src/pages/page-reset-password.vue